import type { TokenResponse, UserResponse } from "../types";
import { request } from "./client";

export function register(
	email: string,
	password: string,
	name: string,
): Promise<TokenResponse> {
	return request("/api/auth/register", {
		method: "POST",
		body: JSON.stringify({ email, password, name }),
	});
}

export function login(email: string, password: string): Promise<TokenResponse> {
	return request("/api/auth/login", {
		method: "POST",
		body: JSON.stringify({ email, password }),
	});
}

export function getMe(): Promise<UserResponse> {
	return request("/api/auth/me");
}

export function updateProfile(data: {
	name?: string;
	language?: string;
}): Promise<UserResponse> {
	return request("/api/auth/me", {
		method: "PATCH",
		body: JSON.stringify(data),
	});
}

export function changePassword(
	current_password: string,
	new_password: string,
): Promise<void> {
	return request("/api/auth/me/password", {
		method: "POST",
		body: JSON.stringify({ current_password, new_password }),
	});
}

export function markOnboardingComplete(): Promise<UserResponse> {
	return request("/api/auth/me", {
		method: "PATCH",
		body: JSON.stringify({ onboarding_complete: true }),
	});
}
